export default function($) {
  $('#subject').on('change', function () {
    if (this.value == "entreprise-alternant") {
      $('#company').prop('required', true);
      $('#company-field').removeClass('hidden');
    } else {
      $('#company').prop('required', false);
      $('#company-field').addClass('hidden');
    }
  });
}
